import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import DtoPutOrderPoolExpress_File_OrderPoolExpressFile from "./DtoPutOrderPoolExpress_File_OrderPoolExpressFile";
import UiGroup from "./UiGroup";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPutOrderPoolExpress_File extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.Files = [];
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 文件
     */
    Files?: DtoPutOrderPoolExpress_File_OrderPoolExpressFile[];
}

/**
 * -表单校验
 */
export const DtoPutOrderPoolExpress_FileRules = {
}

/**
 * -设置项
 */
export const DtoPutOrderPoolExpress_FileMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Files",
    Label: "文件",
    Customize: true,
  },
]
